<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="co-question">
        <span class="co-bar co-bar--xl"></span>
      </div>
      <ol class="co-list">
        <li
          v-for="(item, i) in items"
          :key="item.id"
          class="co-row"
          :class="{ '--moved': i === 1 }"
        >
          <span class="co-num">{{ i + 1 }}</span>
          <span class="co-bar co-bar--md"></span>
          <span class="material-symbols-rounded co-grip">drag_indicator</span>
        </li>
      </ol>
    </template>

    <template #audience>
      <span class="co-phone-q"></span>
      <ol class="co-phone-list">
        <li
          v-for="(item, i) in items"
          :key="'p' + item.id"
          class="co-phone-row"
          :class="{ '--lifted': i === 2 }"
        >
          <span class="co-phone-num">{{ i + 1 }}</span>
          <span class="co-bar co-bar--md"></span>
          <span class="material-symbols-rounded co-phone-grip">drag_indicator</span>
        </li>
      </ol>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewCorrectOrder',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  data() {
    return {
      items: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
    }
  },
})
</script>

<style scoped lang="scss">
.co-bar {
  display: block; height: 7px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.16);
}
.co-bar--xl { width: 70%; height: 8px; background: rgba(15,15,20,0.2); }
.co-bar--md { width: 65%; }

.co-question {
  padding-bottom: 6px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.co-list {
  list-style: none; margin: 0; padding: 0;
  display: grid; gap: 6px;
}
.co-row {
  display: grid;
  grid-template-columns: 22px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.08);
  border-radius: 8px;
}
.co-row.--moved {
  border-color: color-mix(in srgb, var(--accent) 60%, transparent);
  background: color-mix(in srgb, var(--accent) 8%, white);
  animation: co-shift 4s ease-in-out infinite;
}
.co-num {
  width: 22px; height: 22px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.06);
  color: rgba(15, 15, 20, 0.55);
  font-size: 11px; font-weight: 700;
  display: grid; place-items: center;
}
.co-row.--moved .co-num {
  background: var(--accent); color: white;
}
.co-grip {
  font-size: 14px;
  color: rgba(15, 15, 20, 0.3);
}
.co-row.--moved .co-grip { color: var(--accent); }

/* ---- Audience phone ---- */
.co-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.co-phone-list {
  list-style: none; margin: 0; padding: 0;
  display: grid; gap: 4px;
}
.co-phone-row {
  display: grid;
  grid-template-columns: 18px 1fr auto;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.08);
  border-radius: 6px;
}
.co-phone-row.--lifted {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, white);
  box-shadow: 0 4px 8px -2px color-mix(in srgb, var(--accent) 30%, transparent);
  animation: co-lift 4s ease-in-out infinite;
}
.co-phone-num {
  width: 18px; height: 18px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.06);
  color: rgba(15, 15, 20, 0.55);
  font-size: 9px; font-weight: 700;
  display: grid; place-items: center;
}
.co-phone-row.--lifted .co-phone-num {
  background: var(--accent); color: white;
}
.co-phone-grip {
  font-size: 13px;
  color: rgba(15, 15, 20, 0.3);
}
.co-phone-row.--lifted .co-phone-grip { color: var(--accent); }

@keyframes co-shift {
  0%, 30%  { transform: translateY(0); }
  60%      { transform: translateY(-3px); }
  90%, 100% { transform: translateY(0); }
}
@keyframes co-lift {
  0%, 20%  { transform: translateY(0) scale(1); }
  50%      { transform: translateY(-4px) scale(1.02); }
  80%, 100% { transform: translateY(0) scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .co-row.--moved, .co-phone-row.--lifted { animation: none; }
}
</style>
